import React from 'react';
import { Routes, Route } from 'react-router-dom';
import News from '../pages/index';
import CreateNews from '../pages/create';
import NewsDetail from '../pages/detail';
import EditNews from '../pages/edit';
import DefaultLayout from '../../../layouts/default';
import PrivateOutlet from '../../../components/PrivateOutlet';
import { RouteNameEnum } from '../../../enums/routeName';
import { PermissionEnum } from '../../../enums/permission';

const routes = [
  { privateProperties: { permissionCodes: [PermissionEnum.code.newsViewList] }, routeProperties: { path: RouteNameEnum.news.index, element: <News /> } },
  { privateProperties: { permissionCodes: [PermissionEnum.code.newsCreate], redirectUrl: RouteNameEnum.news.index }, routeProperties: { path: RouteNameEnum.news.create, element: <CreateNews /> } },
  { privateProperties: { permissionCodes: [PermissionEnum.code.newsViewList], redirectUrl: RouteNameEnum.news.index }, routeProperties: { path: RouteNameEnum.news.detail, element: <NewsDetail /> } },
  { privateProperties: { permissionCodes: [PermissionEnum.code.newsEdit], redirectUrl: RouteNameEnum.news.index }, routeProperties: { path: RouteNameEnum.news.edit, element: <EditNews /> } },
];

const BaseRoutes: React.FC = () => (
  <Routes>
    <Route element={<DefaultLayout />}>
      {routes.map((route) => (
        <Route key={route.routeProperties.path} element={<PrivateOutlet {...route.privateProperties} />}>
          <Route key={`inner-${route.routeProperties.path}`} {...route.routeProperties} />
        </Route>
      ))}
    </Route>
  </Routes>
);

export default BaseRoutes;
